export default __webpack_public_path__ + "static/media/dot-failed.888f857c.svg";